import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../stores/CurrentCompanyStore'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { LoadingAnimation } from '../../components/LoadingAnimation'
import { printHTML } from '../../utilities/helpers'
import { ShiftReceipt } from './Receipt/ShiftReceipt'
import { ShiftApi, ShiftModels } from '@getgreenline/shifts'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  shiftId: number
  onHide: () => void
}

interface State {
  shift?: ShiftModels.IShift
  showInventorySold: boolean
  errorMessage?: string
}

@inject('currentCompanyStore')
@observer
export class ShiftSummaryModal extends React.Component<React.PropsWithChildren<Props>, State> {
  constructor(props: React.PropsWithChildren<Props>) {
    super(props)
    this.state = {
      showInventorySold: false,
    }
  }

  componentDidMount() {
    const company = this.props.currentCompanyStore!.company!
    ShiftApi.getShiftById(company.id, this.props.shiftId).then((shift) => {
      this.setState({ shift: shift })
    })
  }

  printReceipt() {
    const company = this.props.currentCompanyStore!.company!
    printHTML('print-section', company.name)
  }

  render() {
    const company = this.props.currentCompanyStore!.company!
    const shift = this.state.shift

    return (
      <Modal isOpen={true} toggle={() => this.props.onHide()} autoFocus={false}>
        <ModalHeader toggle={() => this.props.onHide()}>Shift details</ModalHeader>
        <ModalBody>
          {!shift ? (
            <div>
              <LoadingAnimation />
            </div>
          ) : (
            <div>
              <ShiftReceipt
                company={company}
                shift={shift}
                showInventorySold={this.state.showInventorySold}
              />

              <div className='form-group'>
                <div className='form-check'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    checked={this.state.showInventorySold}
                    onChange={() =>
                      this.setState({ showInventorySold: !this.state.showInventorySold })
                    }
                  />
                  <span className='form-check-label'>Show inventory sold</span>
                </div>
              </div>
              <div>
                <button
                  className='btn btn-lg btn-light w-100'
                  onClick={() => {
                    this.printReceipt()
                  }}
                >
                  <span className='fa fa-print mr-2' />
                  Print end-of-shift receipt
                </button>
              </div>
              {this.props.children}
            </div>
          )}
        </ModalBody>
      </Modal>
    )
  }
}
